import {COEFFICIENTS} from "../constants";

export const calculateKPI = (factors, time) => {
    if(!time) return 0;
    const {
        BLOWS,
        BLOWS_2,
        GOALS,
        PERCENTS_ACCURATE_PASS,
        PERCENTS_NO_ACCURATE_PASS,
        EFFECTIVE_STROKES,
        GOALS_PASS,
        SELECTIONS,
        LOSSES
    } = factors;
    return (COEFFICIENTS["BLOWS"] * BLOWS +
        COEFFICIENTS["BLOWS_2"] * BLOWS_2 +
        COEFFICIENTS["GOALS"] * GOALS +
        COEFFICIENTS["PERCENTS_ACCURATE_PASS"] * PERCENTS_ACCURATE_PASS +
        COEFFICIENTS["PERCENTS_NO_ACCURATE_PASS"] * PERCENTS_NO_ACCURATE_PASS +
        COEFFICIENTS["EFFECTIVE_STROKES"] * EFFECTIVE_STROKES +
        COEFFICIENTS["GOALS_PASS"] * GOALS_PASS +
        COEFFICIENTS["SELECTIONS"] * SELECTIONS +
        COEFFICIENTS["LOSSES"] * LOSSES
    )/(Math.ceil(time/60))
}

export const calculateGoalkeeperKPI = (factors, time) => {
    if(!time) return 0;
    const {
        BLOWS,
        BLOWS_2,
        GOALS,
        PERCENTS_ACCURATE_PASS,
        PERCENTS_NO_ACCURATE_PASS,
        EFFECTIVE_STROKES,
        GOALS_PASS,
        SAVES,
        MISSED_BALLS
    } = factors;
    return (
        COEFFICIENTS["BLOWS"] * BLOWS +
        COEFFICIENTS["BLOWS_2"] * BLOWS_2 +
        COEFFICIENTS["GOALS"] * GOALS +
        COEFFICIENTS["PERCENTS_ACCURATE_PASS"] * PERCENTS_ACCURATE_PASS +
        COEFFICIENTS["PERCENTS_NO_ACCURATE_PASS"] * PERCENTS_NO_ACCURATE_PASS +
        COEFFICIENTS["EFFECTIVE_STROKES"] * EFFECTIVE_STROKES +
        COEFFICIENTS["GOALS_PASS"] * GOALS_PASS +
        COEFFICIENTS["SAVES"] * SAVES +
        COEFFICIENTS["MISSED_BALLS"] * MISSED_BALLS
    )/(Math.ceil(time/60))
}

export const calculateRank = (players, playerId) => {
    const playersWithKpi = players.filter(player => player.kpi);
    playersWithKpi.sort((p1, p2) => p2.kpi - p1.kpi);
    const rank = playersWithKpi.findIndex(player => player.id === playerId);
    return rank !== -1 ? rank + 1 : 0
}